module.exports = __webpack_public_path__ + "static/media/Eyebrows_blond.0797063f.svg";